export const CATEGORY_LIST_CLEAR_STORE = "CATEGORY_LIST_CLEAR_STORE";

export const CATEGORY_LIST_SUMMURY_LOAD_START = "CATEGORY_LIST_SUMMURY_LOAD_START";
export const CATEGORY_LIST_SUMMURY_LOAD_SUCCESS = "CATEGORY_LIST_SUMMURY_LOAD_SUCCESS";
export const CATEGORY_LIST_SUMMURY_LOAD_FAIL = "CATEGORY_LIST_SUMMURY_LOAD_FAIL";

export const CATEGORY_LIST_LOAD_START = "CATEGORY_LIST_LOAD_START";
export const CATEGORY_LIST_LOAD_SUCCESS = "CATEGORY_LIST_LOAD_SUCCESS";
export const CATEGORY_LIST_LOAD_FAIL = "CATEGORY_LIST_LOAD_FAIL";

export const CATEGORY_LIST_REMOVE_START = "CATEGORY_LIST_REMOVE_START";
export const CATEGORY_LIST_REMOVE_SUCCESS = "CATEGORY_LIST_REMOVE_SUCCESS";
export const CATEGORY_LIST_REMOVE_FAIL = "CATEGORY_LIST_REMOVE_FAIL";
